<template>
  <div class="transaction-item-info">
    <div class="transaction-item-info__item">
      <div class="transaction-item-info__group">
        <div class="transaction-item-info__title">
          {{ $t('operation-information.cryptocurrency-project.account-id') }}
        </div>
        <div class="transaction-item-info__value"></div>
      </div>
      <div class="transaction-item-info__group">
        <div class="transaction-item-info__title">
          {{ $t('operation-information.cryptocurrency-project.uri-checkout') }}
        </div>
        <div class="transaction-item-info__value"></div>
      </div>
    </div>
    <div class="transaction-item-info__item">
      <div class="transaction-item-info__group">
        <div class="transaction-item-info__title">
          {{ $t('operation-information.cryptocurrency-project.signature') }}
        </div>
        <div class="transaction-item-info__value"></div>
      </div>
      <div class="transaction-item-info__group">
        <div class="transaction-item-info__title">
          {{ $t('operation-information.cryptocurrency-project.uuid') }}
        </div>
        <div class="transaction-item-info__value"></div>
      </div>
    </div>
    <div class="transaction-item-info__item">
      <div class="transaction-item-info__group">
        <div class="transaction-item-info__title">
          {{ $t('operation-information.cryptocurrency-project.sum') }}
        </div>
        <div class="transaction-item-info__value"></div>
      </div>
      <div class="transaction-item-info__group"></div>
    </div>
  </div>
</template>

<script>
import { Transaction } from '@js-app/entities/transaction/Transaction'

export default {
  name: 'TransactionItemCryptocurrencyProjectInfo',
  props: {
    transaction: {
      type: Transaction,
    },
  },
}
</script>
